module.exports = __webpack_public_path__ + "45038d58ac694e29ee707618378a3592.svg";